<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.58691 12.1V10.72"
      stroke="currentColor"
      stroke-linecap="round"
    />
    <path d="M8 12.1V9.33997" stroke="currentColor" stroke-linecap="round" />
    <path
      d="M11.4131 12.1V7.95337"
      stroke="currentColor"
      stroke-linecap="round"
    />
    <path
      d="M11.4136 3.90002L11.1069 4.26002C9.40691 6.24669 7.12691 7.65336 4.58691 8.28669"
      stroke="currentColor"
      stroke-linecap="round"
    />
    <path
      d="M9.45996 3.90002H11.4133V5.84669"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.99967 14.6667H9.99967C13.333 14.6667 14.6663 13.3334 14.6663 10V6.00004C14.6663 2.66671 13.333 1.33337 9.99967 1.33337H5.99967C2.66634 1.33337 1.33301 2.66671 1.33301 6.00004V10C1.33301 13.3334 2.66634 14.6667 5.99967 14.6667Z"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: "dashboard-icon",
};
</script>

<style scoped></style>
